import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-6" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Popular JtelFiber plans"),
  /*#__PURE__*/_createElementVNode("div", { class: "subtitle-1 mt-n1" }, "Recharge packs with unlimited benefits")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Postpaid", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Prepaid", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_jt_postpaid_plans = _resolveComponent("jt-postpaid-plans")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "gray-bg no-shadow" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_v_row, { class: "mt-3 mx-8" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "d-flex justify-center cursor-pointer"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_chip_group, {
                class: "text-center",
                style: {"overflow":"hidden"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: "/fiber-postpaid-plans-home",
                            class: "color-white"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_chip, { class: "px-16 py-5 active" }, {
                                default: _withCtx(() => [
                                  _hoisted_2
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: "/fiber-prepaid-plans-home",
                            class: "color-white"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_chip, { class: "px-16 py-5 active" }, {
                                default: _withCtx(() => [
                                  _hoisted_3
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { class: "mt-0 mt-md-6" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              ($setup.plan == 2)
                ? (_openBlock(), _createBlock(_component_jt_postpaid_plans, { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}